import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dropdown-list',
    templateUrl: './dropdown-list.component.html',
    styleUrls: ['./dropdown-list.component.scss'],
    standalone: false
})

export class DropdownListComponent {
  @Input() public header = '';
  @Input() public alignLeft = true;
}
